import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {MeterReadingsPage} from '../../modals/meter-readings/meter-readings.page';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';

@Component({
    selector: 'meters-readings-taken',
    templateUrl: './meters-readings-taken.component.html',
    styleUrls: ['./meters-readings-taken.component.scss'],
})
export class MetersReadingsTakenComponent implements OnInit {

    @Input() document: DocumentModel;
    mandatoryReadings: Array<any>;

    constructor(private modalController: ModalController,
                private stateManager: StateManagerService,
                private collNames: CollectionsNames) {
    }

    ngOnInit() {
    }

    async meterReadingsModal() {
        const meterReadingTypes = this.stateManager.getCollection(this.collNames.METERTYPE);
        if (meterReadingTypes.length <= 0) {
            alert('No Meter Reading types recorded');
            return;
        }
        const modal = await this.modalController.create({
            component: MeterReadingsPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
            }
        });
        return await modal.present();

    }
}
